import { ActionTypes } from "../constants/actionTypes";

const initialState = {
  isLoading: false,
};

export default function loaderReducer(state = initialState, action) {
  const { type } = action;
  
  switch (type) {
    case ActionTypes.SET_LOADER:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.UNSET_LOADER:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }

}
